import { useEffect } from 'react'
import { useNavigate } from 'react-router'

// evertel
import { Button, Card, CardBody, Row, InfoBox } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { Analytics } from '@evertel/analytics'


const CrisisSplash = () => {

    const analytics = useService(Analytics)
    const navigate = useNavigate()

    useEffect(() => {
        analytics.logView('/crisissplash')
    }, [])

    const onCrisisContinue = () => {
        navigate('/register?crisis=true')
    }

    return (
        <div className="app fadeIn animated auth-layout" style={{ height: '100vh', overflow: 'auto' }}>
            <Row align="center" valign="center" className="p-4" style={{ minHeight: '100%' }}>
                <Card className="" style={{ maxWidth: 800 }}>
                    <CardBody className="p-4">
                        <div className="pb-4">
                            <h1 className="pb-3 weight-900" style={{ fontSize: '3rem' }}>
                                Responding to a crisis event?
                            </h1>
                            <p className="h5 pb-3">
                                If you're responding to a crisis event and your agency is not registered on
                                Evertel you can still collaborate with the agencies responding.<br /><br />
                                You will be taken through a quick and free registration.
                            </p>
                            <InfoBox color="warning">
                                <strong>A government email address is required.</strong>
                            </InfoBox>
                            <Row align="right" className=" d-flex align-items-center mt-4">
                                <Button
                                    color="link"
                                    className="me-5"
                                    size="md"
                                    onClick={() => navigate('/login')}>
                                    Back
                                </Button>
                                <Button
                                    color="primary"
                                    className="fw-bold"
                                    onClick={onCrisisContinue}>
                                    Continue...
                                </Button>
                            </Row>
                        </div>
                    </CardBody>
                </Card>
            </Row>
        </div>
    )
}

export { CrisisSplash }
